import type { DiamRoleAccessDuration } from '../../../diamApi';

export const REQUEST_ACCESS_DURATIONS = [
  { value: '1-hour', label: '1 hour' },
  { value: '1-day', label: '1 day' },
  { value: '1-week', label: '1 week' },
  { value: 'permanent', label: 'Permanent' },
] as const;

export type RequestAccessDuration =
  (typeof REQUEST_ACCESS_DURATIONS)[number]['value'];

export interface RequestAccessFormData {
  justification: string;
  duration: RequestAccessDuration;
}

export const DEFAULT_REQUEST_ACCESS_VALUES: RequestAccessFormData = {
  justification: '',
  duration: '1-day',
};

const REQUEST_ACCESS_DURATION_API_VALUES: Record<
  RequestAccessDuration,
  DiamRoleAccessDuration | null
> = {
  '1-hour': 'PT1H',
  '1-day': 'P1D',
  '1-week': 'P7D',
  permanent: null,
};

export function toRoleAccessRequestDuration(
  duration: RequestAccessDuration,
): DiamRoleAccessDuration | null {
  return REQUEST_ACCESS_DURATION_API_VALUES[duration];
}
